module.exports = __webpack_public_path__ + "Flag-300.b84374a32f0741686dda53799d10b2ad.svg";